var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentIconOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9989 21.6001C17.3009 21.6001 21.5989 17.3021 21.5989 12.0001C21.5989 6.69821 17.3009 2.40015 11.9989 2.40015C6.69699 2.40015 2.39893 6.69821 2.39893 12.0001C2.39893 17.3021 6.69699 21.6001 11.9989 21.6001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4988 8.00012C17.9588 8.00012 18.4088 7.95012 18.8388 7.88012C17.4388 5.56012 14.8988 4.00012 11.9987 4.00012C11.5387 4.00012 11.0887 4.05012 10.6587 4.12012C12.0588 6.44012 14.5988 8.00012 17.4988 8.00012Z",
    fill: "#35B1D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07748 5.03015C6.36748 6.00015 5.04748 7.58015 4.41748 9.47015C6.12748 8.50015 7.44748 6.92015 8.07748 5.03015Z",
    fill: "#35B1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 4C14.9 4 17.44 5.56 18.84 7.88C18.41 7.95 17.96 8 17.5 8C14.6 8 12.06 6.44 10.66 4.12C11.09 4.05 11.54 4 12 4ZM8.08 5.03C7.45 6.92 6.13 8.5 4.42 9.47C5.05 7.58 6.37 6 8.08 5.03ZM12 20C7.59 20 4 16.41 4 12C4 11.95 4.01 11.9 4.01 11.85C6.61 10.87 8.69 8.86 9.75 6.3C11.58 8.56 14.37 10 17.5 10C18.25 10 18.97 9.91 19.67 9.76C19.88 10.47 20 11.22 20 12C20 16.41 16.41 20 12 20Z",
    fill: "#185669"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99756 14.2501C9.68791 14.2501 10.2476 13.6904 10.2476 13.0001C10.2476 12.3098 9.68791 11.7501 8.99756 11.7501C8.3072 11.7501 7.74756 12.3098 7.74756 13.0001C7.74756 13.6904 8.3072 14.2501 8.99756 14.2501Z",
    fill: "#185669"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9971 14.2501C15.6874 14.2501 16.2471 13.6904 16.2471 13.0001C16.2471 12.3098 15.6874 11.7501 14.9971 11.7501C14.3067 11.7501 13.7471 12.3098 13.7471 13.0001C13.7471 13.6904 14.3067 14.2501 14.9971 14.2501Z",
    fill: "#185669"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIconOn);
export default __webpack_public_path__ + "static/media/studentIconOn.e5f8493127225e94d2cf77f3c7d8c670.svg";
export { ForwardRef as ReactComponent };